import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ProgressBarStyle } from './../styles'

export default class ProgressBar extends Component{
  static defaultProps = {
    big: false,
  }

  render() {
    const { theme, x, big } = this.props
    return (
      <div className={`progress-bar ${ ProgressBarStyle(theme, x , big) }`}>
        <div className="progress-bar--inner"></div>
      </div>
    )
  }
}

ProgressBar.propTypes = {
  theme: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/ProgressBar.js